import React from "react";
import { useHistory } from "react-router-dom";
import { SVGICONS } from "config";

const PageHeaderV2 = ({ pageTitle }) => {
  const history = useHistory();

  return (
    <header className="fixed top-0 max-460 flex justify-between items-center w-full">
      <div className="flex justify-between items-center bg-white p-4 w-full">
        <button
          onClick={() => history.goBack()}
          className="w-10 h-10 flex items-center justify-center"
        >
          <SVGICONS.BackArrow width={24} height={24} />
        </button>
        <h2 className="m-0 text-20x font-bold text-shadow-forge-900">
          {pageTitle}
        </h2>
        <div className="w-10 h-10" />
      </div>
    </header>
  );
};

export default PageHeaderV2; 